module.exports = __webpack_public_path__ + "img/red-logo.af224832.png";